import { ResourceHelperService } from '../resource-helper.service';

/**
 * A dataservice that provides CRUD operations on transport operator service entries
 * against the backend transport operator services service
 */
export class TransportOperatorServicesService {

  private resource: InterACT.Interfaces.IResource<InterACT.Interfaces.TransportOperatorServices.TransportOperatorServicesResponse | InterACT.Interfaces.TransportOperatorServices.TransportOperatorServicesResponse>;

  constructor(
    private $resource: ng.resource.IResourceService,
    private resourceHelperService: ResourceHelperService
  ) {
    this.resource = $resource('api/transport-operator-services');
  }

  /**
   * Function to retrieve a record from the Transport Operator Services backend service
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param searchText The search text used to build up a query string in the outgoing http request
   * @returns A http promise
   */
  public getList(page: number, perPageCount: number, searchText?: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, searchText);
    return <ng.IPromise<InterACT.Interfaces.TransportOperatorServices.TransportOperatorServicesResponse>>this.resource.get(options).$promise;
  }
}
